export default __webpack_public_path__ + "static/media/logout_icon_gray.72e33412.svg";